/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · Brazilian Portuguese (pt) string table
   English is the source of truth in the HTML; this file supplies the
   Portuguese counterpart for each data-i18n key. Missing keys fall back
   to English automatically (see i18n.js). Hand this file to a translator
   or compliance reviewer; it is the single place Portuguese copy lives.

   House voice: calm, exact, short. Brazilian Portuguese (pt-BR), not
   European. Use "você", gerund tenses, BR vocabulary (hidratante, tela,
   geladeira). No em dashes (use periods, commas, or the mid-dot · ).
   Product names (Transderma C/A/O/M/R, Discovery Kit, Moisture Serum)
   stay in English. Standalone "serum" → "sérum".
═════════════════════════════════════════════════════════════════════ */
window.TD_I18N = window.TD_I18N || {};
window.TD_I18N.pt = Object.assign(window.TD_I18N.pt || {}, {

  /* ── Nav (site-wide) ── */
  'nav.shop': 'Loja',
  'nav.science': 'Ciência',
  'nav.concerns': 'Necessidades da pele',
  'nav.story': 'Nossa história',
  'nav.contact': 'Contato',
  'nav.tryus': 'Experimente',
  'nav.faq': 'Perguntas frequentes',
  'nav.drawerCta': 'Experimente · Discovery Kit',
  'nav.drawerFine': 'Cinco sérums vitamínicos · $70 · envio para o mundo todo',

  /* ── Announcement bar (site-wide) ── */
  'announce.0a': '<strong>Frete grátis</strong> em todos os pedidos acima de $150',
  'announce.0b': 'Enviado para o mundo todo a partir de Stockholm',
  'announce.1a': '<strong>Monte uma rotina e ganhe 10% de desconto</strong>',
  'announce.1b': 'Aplicado automaticamente no checkout',
  'announce.2a': 'Experimente os cinco sérums.',
  'announce.2b': '<strong>Frete grátis a partir de $150</strong>',

  /* ── Homepage · hero ── */
  'home.hero.tagline': 'Skincare sem compromissos · Est. 1998',
  'home.hero.h1': '<span class="l1">Sem água.</span><br><span class="l2">Sem conservantes.</span><br><span class="l3">Sem aditivos.</span><br><span class="l4">Sem corantes.</span><br><span class="l5">Sem ar.</span><br><span class="l6"><em class="hero-vitamins-em">Apenas vitaminas ativas.</em></span>',
  'home.hero.sub': 'Formulados para absorção dérmica real, além da superfície.<br>Cinco sérums vitamínicos. Cinco nãos. Um sistema.',
  'home.hero.cta1': 'Explore os sérums',
  'home.hero.cta2': 'Como funciona',

  /* ── Homepage · coming-soon teaser (static only) ── */
  'home.cs.title': 'Campanha<br><em>Verão</em> 2026',
  'home.cs.shop': 'Sérums disponíveis agora',

  /* ── Homepage · press bar ── */
  'home.press.label': 'Visto em',

  /* ── Homepage · collection ── */
  'home.coll.eyebrow': 'A coleção',
  'home.coll.h2': 'Sérums vitamínicos formulados com precisão. <em>Desenvolvidos em Stockholm.</em>',
  'home.coll.viewAll': 'Ver todos os produtos',
  'home.coll.c.benefit': 'Protege, ilumina e firma com vitamina C pura.',
  'home.coll.a.benefit': 'Renovação com retinol enquanto você dorme.',
  'home.coll.o.benefit': 'Energiza as células e devolve luminosidade visível.',
  'home.coll.m.benefit': 'Repara a barreira de hidratação. Profunda e duradoura.',
  'home.coll.r.benefit': 'Firma e restaura. Reduz a aparência de imperfeições, marcas pós-acne e irregularidades de textura ao longo do tempo.',
  'home.coll.kit.name': 'Discovery Kit',
  'home.coll.kit.benefit': 'Os cinco sérums em tamanho de bolso. Experimente o sistema completo antes de decidir.',
  'home.coll.kit.badge': 'Novo',

  /* ── Homepage · science intro (shared) ── */
  'home.science.eyebrow': 'A ciência',
  'home.science.h2': 'A penetração profunda faz<br><em>a diferença.</em>',
  'home.science.body': 'O sistema de transporte da Transderma leva as vitaminas ativas além da epiderme até a derme, onde a síntese de colágeno e a renovação celular realmente acontecem.',
  'home.science.readMore': 'Leia toda a ciência →',

  /* ── Homepage · science skin diagram (static only) ── */
  'home.sci.serumLabel': 'Sérums<br>Transderma',
  'home.sci.l1.label': 'STRATUM CORNEUM',
  'home.sci.l1.desc': 'Camada mais externa da pele',
  'home.sci.l1.p': 'O stratum corneum é a barreira externa da pele: células mortas e compactadas que bloqueiam a maior parte do que aplicamos. A fórmula sem água da Transderma o atravessa em segundos após a aplicação. As vitaminas ativas chegam intactas aos tecidos vivos abaixo, sem perda por evaporação.',
  'home.sci.l1.depth': '0 mm DE PROFUNDIDADE',
  'home.sci.l2.label': 'EPIDERME',
  'home.sci.l2.desc': 'Células vivas da pele, melanócitos, terminações nervosas',
  'home.sci.l2.p': 'A maioria dos sérums para por aqui, depositada entre as células vivas da epiderme, incapaz de ir mais fundo. A Transderma não contém água, então cada gota mantém toda a sua concentração de vitaminas durante o trajeto. Nada é diluído pelo caminho; a fórmula segue avançando rumo à derme.',
  'home.sci.l2.depth': '0,1 mm DE PROFUNDIDADE',
  'home.sci.l2.stop': 'A maioria dos sérums para aqui',
  'home.sci.barrier': 'BARREIRA CUTÂNEA',
  'home.sci.l3.label': 'CAMADA DÉRMICA',
  'home.sci.l3.desc': 'Colágeno, elastina, fibroblastos, vasos sanguíneos',
  'home.sci.l3.p': 'A derme é onde a mudança duradoura da pele realmente acontece: o colágeno, a elastina e a renovação celular começam aqui. A Transderma transporta vitaminas concentradas diretamente para essa camada, onde os fibroblastos podem usá-las. É a camada que os sérums convencionais raramente alcançam, e a razão pela qual nossos resultados aparecem ao longo das semanas.',
  'home.sci.l3.depth': '1–2 mm DE PROFUNDIDADE',
  'home.sci.l4.label': 'TECIDO SUBCUTÂNEO',
  'home.sci.l4.desc': 'Tecido adiposo e suporte estrutural profundo',
  'home.sci.l4.p': 'Abaixo da derme está a camada subcutânea, um tecido adiposo que ancora a pele e mantém seu formato. Nessa profundidade, as vitaminas da Transderma já foram absorvidas pela derme acima. O tecido aqui é a base estrutural da renovação que acontece em cada camada construída por cima.',
  'home.sci.l4.depth': '4–10 mm DE PROFUNDIDADE',
  'home.sci.reach': 'A TRANSDERMA ATINGE ESSA PROFUNDIDADE',

  /* ── Homepage · purity / five nos (static + theme strip) ── */
  'home.purity.eyebrow': 'A diferença',
  'home.purity.h2': 'Não é o que<br><em>você espera.</em>',
  'home.purity.water.title': 'Sem água',
  'home.purity.water.body': 'Fórmula sem água. Concentração maior, penetração mais profunda.',
  'home.purity.preserv.title': 'Sem conservantes',
  'home.purity.preserv.body': 'Sem água, micróbios não conseguem se desenvolver. Nenhum é necessário.',
  'home.purity.fillers.title': 'Sem aditivos',
  'home.purity.fillers.body': 'Cada ingrediente é funcional. Sem emulsificantes, espessantes ou agentes de carga.',
  'home.purity.dyes.title': 'Sem corantes',
  'home.purity.dyes.body': 'O tom que você vê vem dos ativos brutos, não de cor adicionada.',
  'home.purity.air.title': 'Sem ar',
  'home.purity.air.body': 'Selado em uma bomba airless. Potência total, da primeira à última gota.',

  /* ── Homepage · pure formulation strip header (liquid only) ── */
  'home.strip.eyebrow': 'Formulação pura',
  'home.strip.h3': 'Apenas vitaminas ativas.<br><em>Nada mais.</em>',

  /* ── Homepage · trust commitments (liquid only) ── */
  'home.trust.cruelty': '<strong>Nunca testado em animais.</strong> Cruelty-free desde o primeiro dia.',
  'home.trust.vegan': '<strong>Formulações veganas.</strong> Nenhum ingrediente de origem animal.',
  'home.trust.made': '<strong>Fabricado em Stockholm.</strong> Aprovado em laboratório pelo Läkemedelsverket.',
  'home.trust.eu': '<strong>Registrado como cosmético na UE.</strong> Vendido em clínicas de 14 países.',

  /* ── Homepage · airless section (liquid only) ── */
  'home.airless.eyebrow': 'Design airless',
  'home.airless.h2': 'Selado da primeira bombada<br><em>até a última.</em>',
  'home.airless.body': 'O ar é o que envelhece um sérum. A bomba airless fecha essa porta. A última gota tem a mesma potência da primeira.',

  /* ── Homepage · sample / discovery kit ── */
  'home.sample.eyebrow': 'Não sabe por onde começar?',
  'home.sample.h2': 'Experimente os cinco<br><em>por $70.</em>',
  'home.sample.body': 'O Transderma Discovery Kit contém versões em tamanho de bolso dos cinco sérums e um guia impresso para montar a sua rotina. Foi assim que a maioria dos nossos clientes de longa data nos conheceu pela primeira vez.',
  'home.sample.bodyTheme': 'O Transderma Discovery Kit contém versões em tamanho de bolso dos cinco sérums. Foi assim que a maioria dos nossos clientes de longa data nos conheceu pela primeira vez.',
  'home.sample.cta': 'Garanta o Discovery Kit',
  'home.sample.fine': '$5 de frete · Inclui o guia impresso de necessidades da pele',
  'home.sample.fineTheme': '$5 de frete para o mundo todo · Enviado de Stockholm',
  'home.sample.f1.h': 'Os cinco sérums',
  'home.sample.f1.p': 'Tamanho de bolso, perfeito para quem está em movimento. Cerca de 7 dias de uso regular.',
  'home.sample.f1.pTheme': 'Frascos de 3 ml em tamanho de bolso, perfeitos para quem está em movimento. Cerca de 7 dias de uso regular por frasco.',
  'home.sample.f2.h': 'Guia de necessidades da pele',
  'home.sample.f2.p': 'Um guia impresso para ajudar você a encontrar os sérums que atendem às suas necessidades específicas.',
  'home.sample.f2.hTheme': 'Os cinco, lado a lado',
  'home.sample.f2.pTheme': 'Teste cada fórmula na sua rotina ao longo da mesma semana e descubra quais combinações funcionam para a sua pele.',
  'home.sample.f3.h': 'Sem compromisso',
  'home.sample.f3.p': 'Descubra se a Transderma é para você. A maioria sabe em poucos dias.',

  /* ── Homepage · skin concerns ── */
  'home.conc.eyebrow': 'Encontre a sua fórmula',
  'home.conc.h2': 'Compre de acordo<br><em>com a sua pele.</em>',
  'home.conc.firm.t': 'Firmeza',
  'home.conc.firm.d': 'Perda de elasticidade e definição na linha da mandíbula e nas bochechas.',
  'home.conc.bright.t': 'Luminosidade',
  'home.conc.bright.d': 'Tom desigual, falta de viço e descoloração causados por exposição ambiental, cicatrizes ou marcas pós-acne.',
  'home.conc.hydrate.t': 'Hidratação',
  'home.conc.hydrate.d': 'Pele seca, descamação e barreira de hidratação enfraquecida que não retém mais a umidade.',
  'home.conc.lines.t': 'Linhas finas',
  'home.conc.lines.d': 'Linhas finas superficiais e rugas de expressão mais profundas que se desenvolvem ao longo do tempo.',
  'home.conc.viewAll': 'Ver todas as necessidades da pele →',

  /* ── Homepage · heritage / founder ── */
  'home.her.caption': 'Dr. Klaus Alvin Ronlán, Ph.D.<br><span>1942 — 2018 · Professor adjunto</span>',
  'home.her.eyebrow': 'O fundador',
  'home.her.h2': 'Trinta anos.<br><em>A mesma fórmula.</em>',
  'home.her.body': 'A Transderma nasceu em um laboratório de Stockholm, fundada pelo Dr. Klaus Alvin Ronlán após vinte e cinco anos de pesquisa na Universidade de Lund. Cinco sérums, lançados em 1998. Preservados inalterados desde o falecimento do Dr. Ronlán em 2018. Ainda independente. Ainda fabricado na Suécia.',
  'home.her.bodyTheme': 'A Transderma nasceu em um laboratório de Stockholm, fundada pelo Dr. Klaus Alvin Ronlán após vinte e cinco anos de pesquisa. Ainda independente. Ainda fabricado na Suécia.',
  'home.her.cta': 'Leia a história do Dr. Ronlán →',

  /* ── Awards · Recognition (site-wide) ── */
  'awards.label': 'Reconhecido',
  'awards.serumC': 'Nordic Natural Beauty Awards · Vencedor 2020',
  'awards.serumA': 'Global Makeup Awards · Silver, Escandinávia 2022',
  'awards.serumO': 'Swedish Beauty &amp; Cosmetics Awards · Vencedor 2016',
  'awards.serumM': 'Nordic Natural Beauty Awards · Vencedor 2020',
  'awards.serumR': 'ELLE Sweden Beauty Awards · Vencedor 2013',
  'awards.fullLine': 'Reconhecido por · ELLE Sweden Beauty Awards · Nordic Natural Beauty Awards · Swedish Beauty &amp; Cosmetics Awards · Global Makeup Awards · LUXlife Magazine',
  'awards.aboutLine': 'Reconhecido · ELLE Sweden 2013 · Swedish Beauty &amp; Cosmetics 2016 · Nordic Natural Beauty 2020 · Global Makeup 2022 · LUXlife 2021',

  /* ── Press pull-quotes (real editorial reviews) ── */
  'quote.home.text': '«Skincare altamente eficaz, no seu mais alto nível.»',
  'quote.home.cite': 'Melissa Davis · The Beauty Librarian',
  'quote.serumR.text': '«Como mágica para a pele. Meu problema de pigmentação no lábio superior desapareceu.»',
  'quote.serumR.cite': 'Teresa Grundin · Styleby, 2014',
  'quote.serumC.text': '«A ciência por trás deste produto e a simplicidade da fórmula são impressionantes.»',
  'quote.serumC.cite': 'Truth In Aging',
  'quote.serumA.text': '«Skincare maximizado. Transderma A e C.»',
  'quote.serumA.cite': 'Teresa Grundin · Elle.se, 2014',

  /* ── Footer (site-wide) ── */
  'footer.tagline': 'Est. 1998 · Stockholm',
  'footer.location': 'Stockholm, Suécia',
  'footer.col.serums': 'Sérums',
  'footer.col.shop': 'Loja',
  'footer.col.learn': 'Descubra',
  'footer.col.support': 'Atendimento',
  'footer.serums.kit': 'Discovery Kit',
  'footer.serums.gift': 'Vale-presente',
  'footer.shop.all': 'Todos os sérums',
  'footer.learn.research': 'Pesquisa do Dr. Ronlán',
  'footer.learn.science': 'A ciência',
  'footer.learn.concerns': 'Necessidades da pele',
  'footer.learn.story': 'Nossa história',
  'footer.learn.about': 'Sobre o Dr. Ronlán',
  'footer.support.faq': 'Perguntas frequentes',
  'footer.support.shipping': 'Frete &amp; devoluções',
  'footer.support.stockists': 'Pontos de venda',
  'footer.support.contact': 'Contato',
  'footer.support.privacy': 'Privacidade',
  'footer.support.terms': 'Termos',
  'footer.copy': '© 2026 Transderma®. Todos os direitos reservados. Stockholm, Suécia.<svg class="ft-flag" viewBox="0 0 60 40" xmlns="http://www.w3.org/2000/svg" aria-label="Brasil"><rect width="60" height="40" fill="#009C3B"/><polygon points="30,6 54,20 30,34 6,20" fill="#FFDF00"/><circle cx="30" cy="20" r="7" fill="#002776"/></svg>',
  'footer.links.privacy': 'Privacidade',
  'footer.links.terms': 'Termos',

  /* ── Certifications strip (homepage) ── */
  'certifications.label': 'Certificações',
  'certifications.ewg': 'EWG Verificado',
  'certifications.certclean': 'CertClean Certificado'

});
